import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectConfiguration } from '../../redux/configuration'

const Translator: FC = ({ children }) => {
  const { data: configuration } = useSelector(selectConfiguration)
  const { i18n } = useTranslation()

  useEffect(() => {
    if (configuration) {
      i18n.changeLanguage(configuration.localization)
    }
  }, [configuration, i18n])

  return <>{children}</>
}

export default Translator
